<div class="pad" dir="rtl">
  <header class="pad__head">
    <h2>קידום המודעה</h2>
    <p>{{ input.adName }}</p>
    <button type="button" class="pad__x" (click)="ref.close()" aria-label="סגור">×</button>
  </header>

  @if (loading) {
    <div class="pad__state"><span class="pad__spinner"></span></div>
  } @else if (data && !data.eligible) {
    <div class="pad__note">{{ data.reason }}</div>
  } @else if (data) {
    <p class="pad__lead">חשיפה נוספת למודעה שכבר פורסמה, לתקופה מוגדרת. המודעה תסומן "ממומן" ותופיע רק בחיפושים שמתאימים לה.</p>
    <div class="pad__options">
      @for (o of data.options; track o.route_id) {
        <button type="button" class="pad__opt" [class.pad__opt--on]="selected?.route_id === o.route_id"
                (click)="selected = o">
          <span class="pad__opt-title">{{ o.label }}</span>
          <span class="pad__opt-days">{{ o.days }} ימים</span>
          <span class="pad__opt-price">₪{{ o.price | number:'1.0-0' }}</span>
        </button>
      }
    </div>
  }

  @if (error) { <div class="pad__error" role="alert">{{ error }}</div> }

  <footer class="pad__foot">
    <button type="button" class="pad__btn pad__btn--ghost" (click)="ref.close()">ביטול</button>
    @if (data?.eligible) {
      <button type="button" class="pad__btn" [disabled]="!selected || starting" (click)="pay()">
        {{ starting ? 'פותח תשלום…' : 'המשך לתשלום' }}
      </button>
    }
  </footer>
</div>
